




























































import { Component, Vue, Prop, Emit } from 'nuxt-property-decorator'
@Component({})
export default class SearchResults extends Vue {
  @Prop({ default: [] }) filteredPois: Array<any>
  @Prop({ default: '' }) searchTerm: string
  @Prop({ default: '' }) categoryFilter: string

  getThumbnail(result: any) {
    return (
      result.heroImages?.[0]?.url &&
      result.heroImages?.[0]?.thumbnails?.small?.url
    )
  }

  @Emit('onMouseLeave')
  onMouseLeave(result: any) {
    return result
  }

  @Emit('onMouseEnter')
  onMouseEnter(result: any) {
    return result
  }
}
